import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { AssigneeModelSchema } from '../../shared/assignee-model.schema';
import { ObjectIdSchema } from '../../shared/object-id.schema';
import { ReassigneeTypeSchema, refineSuggestionReassigneeModel } from '../../shared/reassignee-type.schema';
/**
 * Resolve Unclear Assignment Request Schema
 * POST /api/v2/process-step-assignment/:id/resolve
 * Resolves an unclear assignment by reassigning to another entity.
 * reAssigneeModel discriminates the entity collection — the unclear
 * resolution can land on a user, team, system or external contact.
 * reAssigneeType defaults to 'entity'; when 'suggestion', reAssigneeId is an
 * EntitySuggestion id and reAssigneeModel is restricted to System / Team.
 */ export const ResolveUnclearAssignmentRequestSchema = z.object({
    reAssigneeId: ObjectIdSchema,
    reAssigneeModel: AssigneeModelSchema,
    reAssigneeType: ReassigneeTypeSchema.default('entity')
}).superRefine(refineSuggestionReassigneeModel);
/**
 * Resolve Unclear Assignment Response Schema
 * Returned on successful assignment resolution
 * Returns void - no response body
 */ export const ResolveUnclearAssignmentResponseSchema = z.void();
/**
 * Resolve Unclear Assignment Error Schema
 * Returned when assignment resolution fails
 */ export const ResolveUnclearAssignmentErrorSchema = BaseErrorSchema;

//# sourceMappingURL=resolve-unclear-assignment.schema.js.map